import * as React from "react";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
const SvgChatBubble = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#424D57",
		fillOpacity: .5,
		fillRule: "evenodd",
		d: "M30 55.556c-3.556 0-7.111-.667-10.222-1.778L8.888 60V47.556C3.334 42.444 0 35.556 0 27.778 0 12.444 13.333 0 30 0s30 12.444 30 27.778c0 15.333-13.333 27.778-30 27.778zM18.889 24.444c-1.778 0-3.333 1.556-3.333 3.334s1.555 3.333 3.333 3.333c1.778 0 3.333-1.555 3.333-3.333 0-1.778-1.555-3.334-3.333-3.334zm11.111 0c-1.778 0-3.333 1.556-3.333 3.334S28.222 31.11 30 31.11c1.778 0 3.333-1.555 3.333-3.333 0-1.778-1.555-3.334-3.333-3.334zm11.111 0c-1.778 0-3.333 1.556-3.333 3.334s1.555 3.333 3.333 3.333c1.778 0 3.333-1.555 3.333-3.333 0-1.778-1.555-3.334-3.333-3.334z"
	})
});
export default SvgChatBubble;
